/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ol.breadcrumb[_ngcontent-%COMP%]{margin-top:-1.5rem}"];
export { styles as styles };



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.component.scss.shim.ngstyle.js.pre-build-optimizer.js